import React, { useState, useContext } from 'react'
import { Dropdown, Header, Form, Icon } from 'semantic-ui-react'
import {
  FUNCTIONS,
  TECHNOLOGY_TAGS,
  MEDICAL_SPECIALTIES,
} from '../../constants/categories'
import DataContext from '../../contexts/DataContext'

export const DEFAULT_EXPERTISE = {
  description: '',
  functions: [],
  technology_tags: [],
  medical_specialties: [],
}

const Expertis = ({ profile, setProfile }) => {
  const { advisor } = useContext(DataContext)

  const EXPERT_TAG_DATA = {
    functions: {
      availableTags: FUNCTIONS,
      expertTags: profile.functions,
    },
    technology_tags: {
      availableTags: TECHNOLOGY_TAGS,
      expertTags: profile.technology_tags,
    },
    medical_specialties: {
      availableTags: MEDICAL_SPECIALTIES,
      expertTags: profile.medical_specialties,
    },
  }

  const getOptions = (category) => {
    const expertTagData = EXPERT_TAG_DATA[category]
    const defaultOptions = expertTagData.availableTags
      .map((obj) => {
        const header = obj.header && {
          key: obj.header,
          text: obj.header,
          value: obj.header,
          content: (
            <Header
              style={{
                fontWeight: 600,
                textTransform: 'uppercase',
                fontSize: '12px',
              }}
            >
              <Icon name={obj.icon} color="black" />
              {obj.header}
            </Header>
          ),
          disabled: true,
          style: { opacity: 1 },
        }
        const items = obj.items.map((item) => ({
          key: item,
          text: item,
          value: item,
        }))
        return header ? [header, ...items] : [...items]
      })
      .flat(1)

    const userCreatedOptions = expertTagData.expertTags
      .filter((tag) => !defaultOptions.map((item) => item.value).includes(tag))
      .map((tag) => ({ key: tag, text: tag, value: tag }))

    return defaultOptions.concat(userCreatedOptions)
  }

  const [functionOptions, setFunctionOptions] = useState(
    getOptions('functions')
  )
  const [technologyOptions, setTechnologyOptions] = useState(
    getOptions('technology_tags')
  )
  const [medicalSpecialtiesOptions, setMedicalSpecialtiesOptions] = useState(
    getOptions('medical_specialties')
  )

  const setFunctions = (functions) => setProfile({ ...profile, functions })
  const setTechnologyTags = (technology_tags) =>
    setProfile({ ...profile, technology_tags })
  const setMedicalSpecialties = (medical_specialties) =>
    setProfile({ ...profile, medical_specialties })

  const handleItem = (type, item) => {
    const handleTypeMethod = (list, setList) => {
      if (list.indexOf(item) === -1) setList(list.concat(item))
      else setList(list.filter((elem) => elem !== item))
    }
    switch (type) {
      case 'function':
        handleTypeMethod(profile.functions, setFunctions)
        break
      case 'technology':
        handleTypeMethod(profile.technology_tags, setTechnologyTags)
        break
      case 'med':
        handleTypeMethod(profile.medical_specialties, setMedicalSpecialties)
        break
      default:
        break
    }
  }

  const renderLabel = (item) => {
    const label = { content: item.text }
    if (
      item.type === 'tagSuggestion' &&
      advisor.expert.tagSuggestions.length > 0
    ) {
      label.className = 'blue-box'
    }
    return label
  }

  const dropdownAttributes = {
    placeholder:
      'Add all that apply from the dropdown and/or Enter a new value',
    fluid: true,
    multiple: true,
    search: true,
    selection: true,
    allowAdditions: true,
  }

  return (
    <div id="expertise-section">
      <Header as="h4">Expertise</Header>
      <div className="content">
        <Form>
          <Form.Field>
            <label>Functions</label>
            <Dropdown
              {...dropdownAttributes}
              value={profile.functions}
              options={functionOptions}
              onAddItem={(e, { value }) => {
                setFunctionOptions([{ text: value, value }, ...functionOptions])
                handleItem('function', value)
              }}
              onChange={(e, { value }) => setFunctions(value)}
              renderLabel={renderLabel}
            />
          </Form.Field>
          <Form.Field>
            <label>Technologies</label>
            <Dropdown
              {...dropdownAttributes}
              value={profile.technology_tags}
              options={technologyOptions}
              onAddItem={(e, { value }) => {
                setTechnologyOptions([
                  { text: value, value },
                  ...technologyOptions,
                ])
                handleItem('technology', value)
              }}
              onChange={(e, { value }) => setTechnologyTags(value)}
              renderLabel={renderLabel}
            />
          </Form.Field>
          <Form.Field>
            <label>Medical Specialties and/or Disease/Research Areas</label>
            <Dropdown
              {...dropdownAttributes}
              value={profile.medical_specialties}
              options={medicalSpecialtiesOptions}
              onAddItem={(e, { value }) => {
                setMedicalSpecialtiesOptions([
                  { text: value, value },
                  ...medicalSpecialtiesOptions,
                ])
                handleItem('med', value)
              }}
              onChange={(e, { value }) => setMedicalSpecialties(value)}
              renderLabel={renderLabel}
            />
          </Form.Field>
          <Form.TextArea
            label="Please use the box below to describe your experience in more detail"
            rows={10}
            value={profile.description}
            onChange={(e, { value }) =>
              setProfile({ ...profile, description: value })
            }
          />
        </Form>
      </div>
    </div>
  )
}

export default Expertis
